import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { can_move_selected_objects, selected_objects_are_for_rotating_edge_tangent } from '../../lattice';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import edit_tangent_vertex_svg from '../../../assets/img/SVG_icons/Top/editing_model/rigid_move.svg';
import { img } from '@phi/components';
import { uid_hide_rigid_move_manipulator, uid_show_rigid_move_manipulator } from '@frontend/ui_display';
import EditTangentAtVertexTooltip from './EditTangentAtVertexTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const EditTangentAtVertexIcon = edit_tangent_vertex_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Edit Tangent';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || !this.state.editing_edge_tangent_mode
                || !(
                    this.state.rigid_move_manipulator
                    || (
                        this.only_one_edge_selected
                        && can_move_selected_objects()
                    )
                );
        },

        active() {
            return this.state.editing_edge_tangent_mode
                && this.state.rigid_move_manipulator;
        },

        only_one_edge_selected() {
            return this.state.selected_edges_count === 1
                && this.state.selected_vertices_count === 0
                && this.state.selected_faces_count === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else if (this.active)
                uid_hide_rigid_move_manipulator(false, 0, true);
            else
                uid_show_rigid_move_manipulator(
                    false,
                    0,
                    true,
                    false,
                    false,
                    selected_objects_are_for_rotating_edge_tangent(),
                    false,
                    false,
                );
        },
    },

    render() {
        return h(BarButton, {
            id: 'edit-edge-tangent-at-vertex-button',
            active: this.active,
            disabled: this.disabled,
            selected: this.state.tut_stage === 8,
            onClick: this.onClick,
            tippy: 'left',
            help: 'edit_tangent',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edit_tangent_vertex_svg, this.alt),
            tooltip: EditTangentAtVertexTooltip,
        });
    },
});
